import { IColumn } from 'core-components/library/list/types'

import { STRATEGIC_INITIATIVES_TRANSLATION_KEYS } from '../../configs/translations'
import { TKeyObjectiveHierarchyItem } from '../../lib'

export const STRATEGIC_INITIATIVES_TABLE_COLUMNS: IColumn<TKeyObjectiveHierarchyItem>[] = [
  {
    field: 'key',
    title: STRATEGIC_INITIATIVES_TRANSLATION_KEYS.keyObjective,
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column, rowAttrs) => (
      <div
        style={{
          paddingLeft: rowAttrs && rowAttrs.deep ? `${rowAttrs.deep * 16}px` : undefined,
        }}
      >
        {item.key}
      </div>
    ),
  },
]
